import {useMutation} from "@tanstack/react-query";
import {setCustomerOfferCoefficientMutationOptions} from "./set-customer-offer-coefficient.mutation-options";

export function useSetCustomerOfferCoefficient(id: string, chapterId: string) {
  return useMutation(setCustomerOfferCoefficientMutationOptions(id, chapterId));
}
